<template>
  <div class="signin-redirect" role="status" aria-live="polite">
    <p>Taking you to sign in&hellip;</p>
  </div>
</template>

<script>
/**
 * The `/login` path, kept as a redirect rather than deleted.
 *
 * The SPA no longer has a login form — the identity provider owns that — but
 * plenty of code still navigates to `/login`: the session-timeout handler, the
 * logout flow, the state machine, and links in already-delivered notification
 * emails. Removing the route made every one of those a "No match for
 * LoginNavigation" router error.
 *
 * Rather than hunt down each caller, `/login` now means what it always meant to
 * the people using it: start signing in. It hands off to the authorization
 * server and preserves wherever they were trying to reach.
 */
import oidc from '@/auth/oidcClient';

export default {
  name: 'SignInRedirect',

  async created() {
    const dest = this.$route.query.dest || this.$route.query.redirect || '/welcome';
    await oidc.beginLogin({ returnTo: dest });
  },
};
</script>

<style scoped>
.signin-redirect {
  min-height: 40vh;
  display: grid;
  place-items: center;
  color: #5c6e6d;
}
</style>
